// extracted by mini-css-extract-plugin
export default {"section":"Settings_section__jlNnd","versionsContainer":"Settings_versionsContainer__0hV+3","chip":"Settings_chip__XhVnt","inputWrapper":"Settings_inputWrapper__LAMVn"};